module.exports = __webpack_public_path__ + "static/media/AB_K36_5.3a33af12.jpg";